export default __webpack_public_path__ + "static/media/marker.4381c90c.svg";